import React from 'react';
import { withTranslation } from 'react-i18next';
import { ModalHeader, Button, ModalBody, Nav, NavItem, NavLink  } from 'reactstrap';
import { modalWrapper } from 'components/FDModal';
import { redirectToCancelUrl, getMerchantData } from 'actions/payment';

const redirectToRetryUrl = () => {
    const { SessionToken, ConfigId } = getMerchantData()
    const retryURL = `?sessionToken=${SessionToken}&configId=${ConfigId}`
    window.location = retryURL
}

const UPIError = props => {
    return (
        <>
            <ModalHeader> {props.t('upi_error_title')} </ModalHeader>
            <ModalBody>
                <div className="text-center mb-3">
                    <span className="icon-info font50"></span>
                    <p className="textGray-16">{props.t('upi_error_content')}</p>
                    { props.retryBtn && <p className="textGray-16">{props.t('retry_with_other')}</p> }
                </div>
                <div className="note-popup">
                    <Nav>
                        {props.t('upi_error_notes', {returnObjects: true}).map(({note}) => (
                            <NavItem key={note}>{note}</NavItem>
                        ))}
                    </Nav>
                </div>
                {
                    props.retryBtn && (
                        <>
                            <div className="d-flex mt-3 mob-btn-trans" role="group">
                                <Button outline color="secondary" onClick={redirectToCancelUrl}>{props.t('cancel_payment')}</Button>
                                <Button onClick={redirectToRetryUrl}>{props.t('retry_payment')}</Button>
                            </div>
                            <div className="goBack">
                            <p>{props.t('cancel_payment_back_to')}<NavLink> {props.t('merchant_site')}</NavLink></p>
                            </div>
                        </>
                    )
                }
                
            </ModalBody>
        </>
    )
}

export default withTranslation('translations')(modalWrapper(true, "GlobalRetry")(UPIError));